import { useMemo } from "react";
import { TraitCategory } from "types";
import { getCategoryIndexByName } from "utils/traitsUtils";

const useCategoryIndex = (categpry: TraitCategory) =>
  useMemo(() => getCategoryIndexByName(categpry), [categpry]);

export default useCategoryIndex;
